export { default } from './icuFormatMessage'
export { icu } from './icuFormatMessage'
export type { ICUFormatMessage } from './icuFormatMessage'
